import React, { useEffect, useState, useMemo } from "react";
import { Redirect } from "react-router-dom";
import { Box, Autocomplete, TextField } from '@mui/material';
import Loader from '../../elements/Loader';
import CourseCard from '../../elements/CourseCard';

const width = window.innerWidth;
const oneColumn = width < 709;

const CodeWarsGroupList = (props) => {
  const { currentUser, groups, fetchGroups, isLoading, history } = props;

  const role = currentUser.optional && currentUser.optional.role

  const avaliableGroups = useMemo(() => (role !== 'admin' ? currentUser?.optional?.groups : groups).filter(el => el.includes("JS")), [role, currentUser, groups]);

  const [search, setSearch] = useState('');

  const filteredGroups = useMemo(() => avaliableGroups.filter(el => search ? el.includes(search.toUpperCase()) : true), [avaliableGroups, search])

  useEffect(() => {
    role === 'admin' && fetchGroups();
    // eslint-disable-next-line 
  }, [])

  return <Box>
    {role !== 'admin' && avaliableGroups.length === 0 && <Redirect to="/noAccess" />}
    {role !== 'admin' && avaliableGroups.length === 1 && <Redirect to={`/codewars/${avaliableGroups[0]}`} />}
    <h1 className="text-center">CodeWars</h1>
    <Box display='flex' justifyContent='center' gap='1.5rem' maxWidth='1450px' marginTop='2rem'>
      {isLoading && <Loader />}
      <Box width={oneColumn ? '15rem' : '31.5rem'} >
        {avaliableGroups?.length > 6 && <Autocomplete
          options={avaliableGroups ?? []}
          freeSolo
          disableClearable
          onSelect={(e) => setSearch(e.target.value)}
          filterOptions={(options) => options.filter(el => search && el.includes(search.toUpperCase()))}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search"
              fullWidth={true}
              InputProps={{
                ...params.InputProps,
                type: 'search',
              }}
            />
          )} />}
      </Box>
    </Box>
    <Box display='flex' justifyContent='center' gap='1.5rem' maxWidth='1450px'>
      <div className='lessons-list'>
        {
          filteredGroups?.map((el, i) => <CourseCard key={i} group={el} onClick={() => history.push(`/codewars/${el}`)} />)
        }
      </div>
    </Box>
  </Box>
};

export default CodeWarsGroupList;
